import { Swiper } from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

Swiper.use([Pagination]);
Swiper.use([Autoplay]);
Swiper.use([Navigation]);

export default () => ({
    carousel: null,

    init() {
        this.carousel = new Swiper(".multi-image-carousel", {
            slidesPerView: 1,
            speed: 1250,
            effect: 'slide',
            centeredSlides: true,
            loop: false,
            pagination: {
                el: ".swiper-pagination",
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<div class="${className} diamond-dot-container gold-variant">
                        <svg class="w-10 h-auto" viewBox="-5 -5 110 110">
                            <polygon class="diamond" points="50,0 90,50 50,100 10,50" />
                            <polygon class="diamond-border" points="50,0 90,50 50,100 10,50" />
                            <polygon class="diamond-active-border animate" points="50,0 90,50 50,100 10,50" />
                            <circle class="indicator" cx="50" cy="50" r="8" />
                        </svg>
                    </div>`;
                },
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 'auto',
                },
            }
        });

        this.carousel.on('slideChange', () => {
            this.updateActiveBullet();
        });
    },

    updateActiveBullet() {
        const activeIndex = this.carousel.realIndex;
        const bullets = document.querySelectorAll('.swiper-custom-pagination .swiper-pagination-bullet');
        bullets.forEach((bullet, index) => {
            if (index === activeIndex) {
                bullet.classList.add('swiper-pagination-bullet-active');
            } else {
                bullet.classList.remove('swiper-pagination-bullet-active');
            }
        });
    }
});